import React from 'react';
import './nlp.css';

const m_wywl2 = () => {
    return (
        <div className="m_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="m_wywl--title">Models and tools</h3>
                <div className='m_wywl--list_block'>
                    <ul className='m_wywl--list'>
                        <li className='m_wywl--list_item'>BERT</li>
                        <li className='m_wywl--list_item'>XLNet</li>
                        <li className='m_wywl--list_item'>GPT-2</li>
                        <li className='m_wywl--list_item'>Transformers</li>
                        <li className='m_wywl--list_item'>Word2Vec</li>
                        <li className='m_wywl--list_item'>Deep Learning Models</li>
                        <li className='m_wywl--list_item'>RNN & LSTM</li>
                        <li className='m_wywl--list_item'>Machine Learning Models</li>
                        <li className='m_wywl--list_item'>ULMFiT</li>
                        <li className='m_wywl--list_item'>Transfer Learning</li>
                    </ul>
                    <ul className='m_wywl--list'>
                        <li className='m_wywl--list_item'>Tensorflow 2.0</li>
                        <li className='m_wywl--list_item'>Hugging Face Transformers</li>
                        <li className='m_wywl--list_item'>PyTorch</li>
                        <li className='m_wywl--list_item'>Theano</li>
                        <li className='m_wywl--list_item'>SpaCy</li>
                        <li className='m_wywl--list_item'>NLTK</li>
                        <li className='m_wywl--list_item'>AllenNLP</li>
                        <li className='m_wywl--list_item'>Stanford CoreNLP</li>
                        <li className='m_wywl--list_item'>Keras</li>
                        <li className='m_wywl--list_item'>FLAIR</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default m_wywl2;